import { LeanTypes } from './types';
const extractNumberTest = (input, testName) => {
    const { tests } = input.describe();
    const test = tests.find(t => t.name === testName);
    return test ? test.params[testName] : undefined;
};
export const extractMin = (input) => extractNumberTest(input, 'min');
export const extractMax = (input) => extractNumberTest(input, 'max');
export const isCodec = (input) => Boolean(input);
export const isYupMetadataLeanSchema = (input) => {
    try {
        const { leanSchema: { type }, } = input;
        return Boolean(type);
    }
    catch (error) {
        return false;
    }
};
export const isArrayInnerType = (input) => { var _a, _b, _c; return Boolean((_c = (_b = (_a = input === null || input === void 0 ? void 0 : input.innerType) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.leanSchema) === null || _c === void 0 ? void 0 : _c.type); };
export const isValidLeanType = (input) => Object.keys(LeanTypes).includes(input);
export const hasValidAdditionalSchemas = (input) => { var _a; return Boolean((_a = input === null || input === void 0 ? void 0 : input.meta) === null || _a === void 0 ? void 0 : _a.additionalSchemas); };
//# sourceMappingURL=utils.js.map